import React, { ReactNode } from "react";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as RouterLink, useLocation } from "react-router-dom";
import PageWithHeader from "../../common/PageWithHeader";

const breadcrumbMap: Record<string, string> = {
  finance: "Finance",
  debtors: "Debtors",
  creditors: "Creditors",
  import: "Import Data",
  invoices: "Invoices",
  "age-analysis": "Age Analysis",
  amortisation: "Amortisation",
  statements: "Statements",
  "vat-statements": "VAT Statements",
  receipts: "Receipts",
  "comprehensive-aging": "Comprehensive Aging",
  cashbook: "Cashbook",
  cashflow: "Cashflow Forecast",
  vat: "VAT Report",
  reports: "Reports",
  "payment-requisitions": "Payment Requisitions",
  "approved-requisitions": "Approved Requisitions",
  "payment-schedule": "Payment Schedule",
  "payments-history": "Payments History",
  "pending-review": "Pending Review",
  "payment-requests-dashboard": "Payment Dashboard",
  "request-to-payment": "Request-to-Payment",
  "petty-cash": "Request-to-Payment",
  rtp: "Request-to-Payment",
  new: "New Request",
  "new-from-po": "Create From Purchase Order",
};

interface FinanceContainerProps {
  children: ReactNode;
}

const FinanceContainer: React.FC<FinanceContainerProps> = ({ children }) => {
  const location = useLocation();

  const isHub =
    location.pathname === "/finance" || location.pathname === "/finance/";

  const segments = location.pathname
    .split("/")
    .filter(Boolean)
    .map((seg, idx, arr) => ({
      label: breadcrumbMap[seg] ?? seg,
      path: "/" + arr.slice(0, idx + 1).join("/"),
    }));

  return (
    <PageWithHeader bgColor="#f5f5f5">
      {/* Finance sub-navigation breadcrumb strip */}
      {!isHub && (
        <Box
          sx={{
            background: "linear-gradient(90deg, #1C4697 0%, #12315A 100%)",
            px: 3,
            py: 1,
          }}
        >
          <Breadcrumbs
            separator={
              <NavigateNextIcon
                fontSize="small"
                sx={{ color: "rgba(255,255,255,0.5)" }}
              />
            }
          >
            <Link
              component={RouterLink}
              to="/finance"
              underline="hover"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                color: "rgba(255,255,255,0.75)",
                fontSize: "0.8rem",
              }}
            >
              <HomeIcon sx={{ fontSize: 14 }} />
              Finance
            </Link>
            {segments.slice(1).map((seg, i, arr) =>
              i === arr.length - 1 ? (
                <Typography
                  key={seg.path}
                  sx={{ color: "white", fontWeight: 600, fontSize: "0.8rem" }}
                >
                  {seg.label}
                </Typography>
              ) : (
                <Link
                  key={seg.path}
                  component={RouterLink}
                  to={seg.path}
                  underline="hover"
                  sx={{ color: "rgba(255,255,255,0.75)", fontSize: "0.8rem" }}
                >
                  {seg.label}
                </Link>
              ),
            )}
          </Breadcrumbs>
        </Box>
      )}

      {/* Page content */}
      <Box sx={{ p: 3 }}>{children}</Box>
    </PageWithHeader>
  );
};

export default FinanceContainer;
